export class FormulaireOutput {
    id = 0
    nom = ''
    description = ''
    dateCreation = ''
    inputs: Array<FormulaireInputOutput> = []
    visibleSiteVitrine = false
    visibleAgentOrtho = false
    visibleAgentDentaire = false
    visibleClientOrtho = false
    visibleClientDentaire = false
    visibleCodir = false
    visibleADV = false
    indexeSiteVitrine = false
    reponseVisibleCodir = false
    reponseVisibleADV = false
    reponseVisibleAdmin = false
    supprime = false
    emailContact = ''
}

export class FormulaireInputOutput {
    id = 0
    titre = ''
    estNumerique = false
    facultatif = false
    ordre = 0
}
